import React, { useState } from 'react';
import { IconClose } from '~/assets/Icons';
import { Button, Modal, Select } from '~/components';
import reportsService from '~/services/reportsService';
import { Content, TitleModal } from './styles';

interface IProps {
  tabs: {
    church: boolean;
    manager: boolean;
  };
  onClose: () => void;
}

const ModalExport: React.FC<IProps> = ({ tabs, onClose }: IProps) => {
  const [yearSelect, setYearSelect] = useState('2023');

  const exportExcel = () => {
    if (tabs.church) {
      reportsService.exportExcelReportChurch({ year: yearSelect });
      onClose();
    }
    reportsService.exportExcelReportLeader({ year: yearSelect });
    onClose();
  };

  return (
    <>
      <Modal width="400px">
        <>
          <TitleModal>
            <button type="button" onClick={onClose}>
              <IconClose />
            </button>
          </TitleModal>
          <Content>
            <Select
              lista={[
                { name: '2022', id: 2 },
                { name: '2023', id: 3 },
              ]}
              currentValue={yearSelect}
              erro=""
              label="Selecione o ano:"
              onClickList={e => setYearSelect(e.name)}
            />
            <span>
              <Button onClick={() => exportExcel()}>Exportar</Button>
            </span>
          </Content>
        </>
      </Modal>
    </>
  );
};

export default ModalExport;
